<template>
  <div class="page-loading" :class="pageLoading ? 'page-loading--active': ''">
    <div v-if="pageLoading" class="spinner" />
    <session-timeout-modal />
    <router-view></router-view>
  </div>
</template>

<script>
import SessionTimeoutModal from '@/components/partials/SessionTimeoutModal.vue'

export default {
  props: {

  },
  components: {
    SessionTimeoutModal
  },
  methods: {

  },
  mounted () {
    if ( !this.$route.params.session_id ) {

      // get uuid from backend
      // let context = this;
      this.$store.dispatch('getUUID')
        .then(response => {
          // console.log(response);
          this.$router.push( { name: 'Vehicle.Plate', params: { session_id: this.$store.state.session_id } } );
        }, error => {
          if( error === 'login_required' ){
            window.location = "/app/login";
          } else {
            // Need to show a generic error, and somehow report the real error back to the site-owners to understand why
            console.error('No valid UUID error', error); // this will trigger sentry
          }
          // context.errors = error;
        })
      return false;
    }
  },
  computed: {
    pageLoading () {
      return this.$store.state.pageLoading;
    }
  },
  data () {
    return {
    }
  }
}

</script>

<style scoped lang="scss">
  
</style>